import React from 'react';
export const Footer = () => {
  return <footer className="py-8 bg-brand-dark border-t border-white/10" data-id="element-75">
      <div className="container px-4 mx-auto text-center" data-id="element-76">
        <p className="text-sm text-gray-500 max-w-4xl mx-auto leading-relaxed" data-id="element-77">
          © 2026 Marketing PRO. Todos los derechos reservados. Este material es
          de uso exclusivo del comprador. Queda prohibida su reproducción,
          distribución o reventa parcial o total sin autorización expresa de
          Marketing PRO.
        </p>
      </div>
    </footer>;
};